import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AppService } from '../app.service';
import { InteractionStatus, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { messageService } from '../message.service';

@Component({
  selector: 'app-login-ad',
  templateUrl: './login-ad.component.html',
  styleUrls: ['./login-ad.component.scss']
})

export class LoginAdComponent {
  href: string;
  app_url: { applicationUrl: string; };
  loading: boolean;
  orgDetail: any;
  isLoggedIn: any;
  userDisplayName: string | undefined;
  loginDisplay: boolean;
  data2: { applicationUrl: string; userName: any; };

  constructor(
    private readonly authService: MsalService,
    private readonly appService: AppService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly message: messageService
  ) {
    this.authService.initialize();
    debugger
    this.app_url = {
      applicationUrl: localStorage.getItem("adapplicationUrl")!,
    }

    this.loading = true;
    this.appService.orgDetails(this.app_url).subscribe((data: any) => {

      this.orgDetail = data;

      localStorage.setItem("adEnabled", data.adEnabled);
      localStorage.setItem("adredirecturl", location.pathname);
      localStorage.setItem("adapplicationUrl", this.app_url.applicationUrl);

      if (data.adEnabled == "Y") {
        this.initCall();
      } else {
        this.router.navigate(['/login']);
      }

      this.userSettings['orgName'] = this.orgDetail.orgShortName;
      this.message.setOrgId(this.orgDetail.orgId);
    });
  }

  userData() {
    const userName = this.userSettings.userName.toUpperCase();

    if (location.href == "http://localhost:4200/login/addd") {
      this.data2 = {
        applicationUrl: "https://predev.one-qms.com/login/astad",
        userName: userName
      }
    } else {
      this.data2 = {
        applicationUrl: localStorage.getItem("adapplicationUrl")!,
        userName: userName
      }
    }

    this.appService.userOrgsByName(this.data2).subscribe((data: any) => {
      if (data.length > 0) {


        localStorage.setItem("userName", data[0].userName + ", " + data[0].userName);
        localStorage.setItem("email", data[0].emailAddress);
        this.message.setUserId(data[0].userId);
        localStorage.setItem("userprofilename", data[0].lastName + " , " + data[0].firstName);
        localStorage.setItem("loggedUserName", userName);
        localStorage.setItem("timezone", data[0].timezone);
        localStorage.setItem("loginMode", "Editable");

        this.isLoggedIn = !!this.authService.instance.getAllAccounts().length;

        if (this.isLoggedIn) {
          this.router.navigate(['/profile']);
        }
      } else {
        this.isLoggedIn = !!this.authService.instance.getAllAccounts().length;

        if (this.isLoggedIn) {
          this.router.navigate(['/profile']);
        }
      }
    })
  }

  private readonly _destroying$ = new Subject<void>();

  configureMsalInstance(clientId: string, tenantId: string): void {
    this.authService.instance = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: location.origin + '/profile',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    };
  }
  userSettings: any = {
    orgName: null,
    password: null,
    userName: null,
    emailAddress: null,
    //tokenId:32156987,
    overridesession: "N",
    isViewMode: "N",
  }

  initCall() {
    this.authService.handleRedirectObservable()
      .pipe(
        filter((response) => response !== null)
      )
      .subscribe((response) => {
        // Authentication is successful, update login status and user details
        this.isLoggedIn = true;
        const account = this.authService.instance.getAccountByUsername(response.account.username);
        this.userDisplayName = account ? account.name : '';
      });

    // Check if the user is already logged in after redirect
    this.isLoggedIn = !!this.authService.instance.getAllAccounts().length;

    // If logged in, get user details (optional)
    if (this.isLoggedIn) {
      const account = this.authService.instance.getAccountByUsername(
        this.authService.instance.getAllAccounts()[0].username
      );
      this.userDisplayName = account ? account.name : '';
    }

    // Handle additional login success events (optional)
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((notification) => notification.eventType === 'msal:loginSuccess')
      )
      .subscribe((result) => {
        // Update login status and user details after successful login
        this.isLoggedIn = true;
        this.getUserDetailsFromResult(result);
      });

    this.href = this.router.url;
    console.log(location);
    const fullpath = location.pathname;
    const splitedPath = fullpath.split("/");
    if (splitedPath.length > 1) {
      splitedPath[1]
    }
    this.isLoggedIn = !!this.authService.instance.getAllAccounts().length;

    // If logged in, get user details (optional)
    if (this.isLoggedIn) {
      const account = this.authService.instance.getAccountByUsername(
        this.authService.instance.getAllAccounts()[0].username
      );
      this.userDisplayName = account ? account.name : '';
    }

    // Handle redirect callback after login
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      })

    if (this.isLoggedIn) {
      this.setLoginDisplay();
    } else {
      this.authEnable();
    }
  }

  isProcessing = true;

  authEnable() {
    this.authService.loginRedirect().subscribe((response) => {

    });
  }

  setLoginDisplay() {
    debugger
    //profile
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.userSettings.userName = this.authService.instance.getAllAccounts()[0].username;

      this.app_url = {
        applicationUrl: localStorage.getItem("adapplicationUrl")!,
      }
      console.log(this.app_url);
      this.loading = true;
      this.appService.orgDetails(this.app_url).subscribe((data: any) => {

        this.orgDetail = data;
        localStorage.setItem("adEnabled", data.adEnabled);
        localStorage.setItem("adredirecturl", location.pathname);

        if (data.adEnabled == "Y") {
          this.userData()
        }

        this.userSettings['orgName'] = this.orgDetail.orgShortName;
        this.message.setOrgId(this.orgDetail.orgId);
      });

    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  getUserDetailsFromResult(result: any): void {
    // Extract user details from the authentication result
    const account = this.authService.instance.getAccountByUsername(result.payload.account.username);
    this.userDisplayName = account ? account.name : '';
  }

  getUserDetails(): void {
    // Get user details from the currently logged-in user (if any)
    const account = this.authService.instance.getAllAccounts()[0];
    this.userDisplayName = account ? account.name : '';
  }


}
